import { render, staticRenderFns } from "./ActionPanelShell.vue?vue&type=template&id=81683b2c&scoped=true"
import script from "./ActionPanelShell.vue?vue&type=script&lang=js"
export * from "./ActionPanelShell.vue?vue&type=script&lang=js"
import style0 from "./ActionPanelShell.vue?vue&type=style&index=0&id=81683b2c&prod&lang=scss&scoped=true"
import style1 from "./ActionPanelShell.vue?vue&type=style&index=1&id=81683b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81683b2c",
  null
  
)

export default component.exports